@if ($configGroupNode() || $switchNode()) {
    <div class="cm-add-menu-items-container">
        <div class="cm-add-menu-items">
            @if ($configGroupNode()) {
                <div matTooltip="Add Variant" class="cm-add-menu-item cm-lights" (click)="addConfigVariant()">+ Add variant</div>
                <div
                    matTooltip="Add Switch"
                    class="cm-add-menu-item cm-lights"
                    [matMenuTriggerFor]="addSwitchMenu"
                    (onMenuOpen)="onMenuOpen()"
                    (onMenuClose)="onMenuClose()"
                >
                    + Add switch
                    <!--Add switch menu-->
                    <mat-menu #addSwitchMenu class="cm-template-add-library">
                        <cm-template-menu>
                            <cm-template-menu-section>
                                <ng-container cm-section-title>
                                    <i class="far fa-random"></i>
                                    Switches
                                </ng-container>
                                <ng-container cm-section>
                                    @for (entry of switchTypes; track entry.name) {
                                        <cm-template-menu-item
                                            [nodeClass]="entry.Switch.getNodeClass()"
                                            (click)="addSwitch(entry)"
                                            [label]="entry.name + ' Switch'"
                                        >
                                        </cm-template-menu-item>
                                    }
                                </ng-container>
                            </cm-template-menu-section>
                        </cm-template-menu>
                    </mat-menu>
                </div>
            } @else {
                @if ($switchNode(); as switchNode) {
                    <div
                        [matTooltip]="'Add Selected ' + $getTemplateSwitchItemLabel()(switchNode) + 's'"
                        class="cm-add-menu-item cm-lights"
                        (click)="addSelectionToSwitch()"
                    >
                        + Add selected
                    </div>
                }
            }
        </div>
    </div>
}
